export const preserveSubjectListSearch = (search: string) => {
  const urlParams = new URLSearchParams(search);
  const unit = urlParams.get('unit');
  const subjectList_type = urlParams.get('SubjectList_type');
  const subjectList_printPublication = urlParams.get(
    'SubjectList_printPublication',
  );
  const subjectList_printIssue = urlParams.get('SubjectList_printIssue');

  const targetUrlParams = new URLSearchParams();
  if (unit) targetUrlParams.set('unit', unit);
  if (subjectList_type)
    targetUrlParams.set('SubjectList_type', subjectList_type);
  if (subjectList_printPublication)
    targetUrlParams.set(
      'SubjectList_printPublication',
      subjectList_printPublication,
    );
  if (subjectList_printIssue)
    targetUrlParams.set('SubjectList_printIssue', subjectList_printIssue);
  return targetUrlParams.toString();
};
